import { AxiosInstance } from 'axios';
import { OrderCartBody } from '@/api/orders/orders.types.ts';

export const createOrdersApi = (api: AxiosInstance) => ({
  orderCart: (contactEmployeeId: number, order: OrderCartBody) =>
    api.post(`/v1/orders/${contactEmployeeId}/order`, order),
});
